import "../../libs/backbone/backbone.ajaxq.adapter.ts";
import Handlebars from 'handlebars';
import GenericView from 'views/generic.view.ts';
import Template from 'text-loader!../templates/reset_password.template.htm';
import 'dhtmlxMessage';
import i18n  from "l10n";

export default GenericView.extend({
    el: $("#container"),
    tagName: 'div',
	template: Handlebars.compile(Template),
	initialize: function () {
        this.render();

        this.fields = {
            newPassword: [this.isEmpty, this.minLengthNumber, this.maxLengthNumber, this.isNoValidPassword],
            confirmPassword: [this.isEmpty, this.sameValues]
        };
	},
	superRender: GenericView.prototype.render,
	render: function () {
		this.superRender();
		var self = this;

		this.$el.html(this.template());
	},
    events:{
		"submit #form": "reset",
		"change .to-validation input": "validateIt",
        "keyup .to-validation input": "validateIt",
	},
	validateIt: function(event)
    {
        var element = $(event.currentTarget).parent();
        var field = {};
        field[element.prop("id")] = this.fields[element.prop("id")]

        //console.info(field);
        this.validateFields( field );
    },
	reset: function() {
        var self = this;

        var has_error = this.validateFields(this.fields);
        //console.info("has error: " + has_error);

        var newPassword = encodeURIComponent($("#newPassword").find("input").val());
        var confirmPassword = encodeURIComponent($("#confirmPassword").find("input").val());
        var token = location.href.split("?")[1].split("=")[1];

        if(!has_error) {
            $.when(window.ping()).then(function(resp) {
                $.ajaxDefaultQ({
                    url: 'rest/auth/password/reset',
                    type: 'POST',
                    data: "token=" + token + "&password=" + confirmPassword,
                    beforeSend: function (xhr) {
                        xhr.setRequestHeader('X-CSRF-TOKEN', window.csrf);
                    }
                }).done(function(response, status, xhr){
                    if(status == "success")
                    {
                        window.open('/#Login','_self');
                    }
                })
                .fail(function(response) {
                    dhtmlx.alert({
                        type: "alert",
                        text: i18n.t("queue.pswd_wrong"),
                        callback: function (result) {
                            $("#newPassword").find("input").val("");
                            $("#confirmPassword").find("input").val("");
                        }
                    });
                })
            });
        }

        return false;
	}
});

